<template>
	<table :class="['plan-return-bars eta', { 'text-color-white': darkTheme }]">
		<tr v-for="(target, row) in targetReturnsProfile" :key="row">
			<td class="text-align-right" :class="{ 'pt-50': row !== 0 }">{{ target.name }}</td>
			<td class="pl-50 plan-return-bars__col" :class="{ 'pt-50': row !== 0 }">
				<div class="plan-return-bars__bar">
					<div
						:style="`width: ${target.return}%`"
						:class="['plan-return-bars__bar-fill', { 'plan-return-bars__bar-fill--theme-dark': darkTheme }]"
					></div>
				</div>
			</td>
		</tr>
	</table>
</template>
<script setup lang="ts">
import { ReturnsTarget } from 'types/plan';

interface Props {
	targetReturnsProfile: Array<ReturnsTarget>;
	darkTheme?: boolean;
}

withDefaults(defineProps<Props>(), {
	darkTheme: false
});
</script>

<style lang="scss" scoped>
.plan-return-bars__col {
	width: 120px;
}
</style>
